module.exports = __webpack_public_path__ + "img/kluce-byvanie.3844b531.svg";